<bz-loading [showLoading]="showLoading">
</bz-loading>

<div class="bmc-ecm-container" *ngIf="!showLoading">
    <h5>{{'ECM.TITLE' | translate}}</h5>
    <div class="bmc-ecm-container__header-container">
        <div class="bmc-ecm-container__external-system-section">
            <h5 class="bmc-ecm-select__external-system-title bz-font-weight--semibold">{{'ECM.EXTERNAL_SYSTEM' | translate}}</h5>
            <label *ngIf="externalSystems && externalSystems.length === 0">{{'ECM.NO_ECM_REPOSITORIES' | translate}}</label>
            <bzg-select *ngIf="externalSystems && externalSystems.length > 0" [placeholder]="'ECM.SELECT_EXTERNAL_SYSTEM' | translate"
                (valueChange)="selectedRepository = null; selectedExternalSystem = $event">
                <bzg-option *ngFor="let externalSystem of externalSystems" [value]="externalSystem">
                    {{externalSystem.displayName}}
                </bzg-option>
            </bzg-select>
        </div>
    </div>
    <div class="bmc-ecm">
        <div class="bmc-ecm-select">
            <div class="bmc-ecm-select__list-section" *ngIf="selectedExternalSystem">
                <label class="bmc-ecm-select__title">{{'ECM.TITLE_SELECT' | translate}}</label>
                <ul class="bmc-ecm-select__list">
                    <li *ngFor="let repository of selectedExternalSystem.nodes" (click)="selectRepository(repository)"
                        class="bz-space--inline-s"
                        [ngClass]="{'bz-color-bg--theme-100': selectedRepository && selectedRepository.id === repository.id}">
                        <span>{{repository.displayName}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bmc-ecm-config" *ngIf="selectedExternalSystem">

            <div class="bmc-ecm-config__container" *ngIf="selectedRepository">
                <div class="bmc-ecm-config__title-container">
                    <label class="bmc-ecm-config__title">{{selectedRepository.repository.displayName}}</label>
                </div>
                <bzg-textarea [(ngModel)]="selectedRepository.repository.description" [rows]="2">
                    {{ 'GLOBAL.DESCRIPTION' | translate }}
                </bzg-textarea>
                <div>
                </div>
                <div class="bmc-ecm-config__tabs-section">
                    <bzg-tab-set (onSelectTab)="selectedTab = $event.index">
                        <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'ECM.PROPERTIES' | translate | uppercase}}">
                            <connect-ecm-properties #propertiesForm [selectedRepository]="selectedRepository" [metadata]="ecmMetadata.properties" [reloadFolders]="reloadFolders.bind(this)"></connect-ecm-properties>
                        </bzg-tab-item>
                        <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'ECM.FOLDERS' | translate | uppercase}}">
                            <connect-ecm-folders #ecmFolders [selectedRepository]="selectedRepository"
                                [selectedFolder]="selectedFolder">
                            </connect-ecm-folders>
                        </bzg-tab-item>
                    </bzg-tab-set>
                </div>
                <div *ngIf="selectedRepository" class="bmc-ecm-config__buttons">
                    <bzg-button-secondary (click)="cancelChanges()">
                        {{ 'GLOBAL.CANCEL' | translate }}
                    </bzg-button-secondary>

                    <bzg-button-primary class="bmc-ecm-config__btn-primary" (click)="saveChanges()">
                        {{ 'GLOBAL.APPLY' | translate }}
                    </bzg-button-primary>
                </div>
            </div>
        </div>

    </div>
</div>